import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken,$qu } from '@/utils/auth'

// create an axios instance
const service = axios.create({
 baseURL: '/api', // url = base url + request url
 // baseURL: '', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000 // request timeout
}) 



// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
	// config.headers.post['Content-Type'] = 'application/json';   //主要是这里
	
	 if (!config.headers['Content-Type']) {
	      config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
	    }
	// config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
	// config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
	//config.headers['kouling'] = $qu('yonghu').kouling
	config.headers['token'] = $qu('kouling')
    // if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
    //   config.headers['X-Token'] = getToken()
    // }
	 // console.log(config) 
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
		if(res.code==500){

			// this.$cun('kouling','')
			// this.$cun('yonghuming','')
			// localStorage.removeItem('yonghu');
			// that.$dakai('denglu');
		}
		
		return res
    // }
  },
  error => {
    // console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)


export default service
